import { FC } from 'react';
import { FormattedMessage } from 'dibs-react-intl';
import { useDispatch } from 'react-redux';
import { createFragmentContainer, graphql } from 'react-relay/legacy';
import { Link } from 'dibs-elements/exports/Link';

import { getValidRespAppliedFilters } from '../SbRespRefineMenu/SbRespRefineMenuFilters/sbRespRefineMenuFiltersMap';
import { clearAllAppliedFiltersHandler } from '../SbSharedAppliedFilters/sbSharedAppliedFiltersHelpers';
import { SbRespRefineMenuDrawerHeader_itemSearch } from './__generated__/SbRespRefineMenuDrawerHeader_itemSearch.graphql';

import styles from './SbRespRefineMenuDrawerHeader.scss';

type Props = {
    itemSearch: SbRespRefineMenuDrawerHeader_itemSearch;
};

const SbRespRefineMenuDrawerHeaderComponent: FC<Props> = ({ itemSearch }) => {
    const dispatch = useDispatch();
    const hasAppliedFilters = !!getValidRespAppliedFilters({
        appliedFilters: itemSearch.appliedFilters || [],
    }).length;
    return (
        <div className={styles.header}>
            <span className={styles.title}>
                <FormattedMessage
                    id="SbRespRefineMenuDrawerHeader.title"
                    defaultMessage="All Filters"
                />
            </span>
            {hasAppliedFilters && (
                <Link
                    className={styles.subtitleCta}
                    onClick={clearAllAppliedFiltersHandler(dispatch, { itemSearch })}
                >
                    <FormattedMessage
                        id="SbRespRefineMenuDrawerHeader.subtitleCta"
                        defaultMessage="Clear All"
                    />
                </Link>
            )}
        </div>
    );
};

export const SbRespRefineMenuDrawerHeader = createFragmentContainer(
    SbRespRefineMenuDrawerHeaderComponent,
    {
        itemSearch: graphql`
            fragment SbRespRefineMenuDrawerHeader_itemSearch on ItemSearchQueryConnection {
                clearAppliedFiltersLinkReference
                appliedFilters {
                    canBeDismissed
                }
            }
        `,
    }
);
